import React from 'react';
import { func, shape } from 'prop-types';
import { Input } from '@fiverr-private/fit';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { marketplaceIntegration } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import { LOCATION, TEXT_FIELDS } from '../../../bi/mixpanel/constants';
import { BRIEF_DATA } from '../../../Listings/constants';
import commonClasses from '../shared/filter.module.scss';
import useDebouncedState from '../../../../../hooks/useDebouncedState';
import { BRAND_NAME_PROP, SLOGAN_PROP } from '../../shared/constants';
import classes from './index.module.scss';

const { reportTextFieldsChanged } = marketplaceIntegration;

const BrandFilter = ({ briefData, setBriefData }) => {
    const [brandState, setDebouncedBrand] = useDebouncedState(
        briefData,
        setBriefData
    );
    const [sloganState, setDebouncedSlogan] = useDebouncedState(
        briefData,
        setBriefData
    );

    return (
        <div className={commonClasses.filterWrapper}>
            <label className={commonClasses.label}>
                <div className={commonClasses.caption}>
                    <I18n k="variations_display.marketplace_listing.filters.brand.brandName.title" />
                </div>
                <Input
                    value={brandState[BRAND_NAME_PROP]}
                    className={classes.input}
                    placeholder={translate(
                        'variations_display.marketplace_listing.filters.brand.brandName.placeholder'
                    )}
                    onChange={(e) => {
                        setDebouncedBrand({
                            [BRAND_NAME_PROP]: e.currentTarget.value,
                        });
                        reportTextFieldsChanged({
                            location: LOCATION.STATIC,
                            field: TEXT_FIELDS.BRAND_NAME,
                        });
                    }}
                />
            </label>

            <label className={commonClasses.label}>
                <div className={commonClasses.caption}>
                    <I18n k="variations_display.marketplace_listing.filters.brand.slogan.title" />{' '}
                    <span className={commonClasses.secondary}>
                        <I18n k="variations_display.marketplace.modal.make_your_logo.keywords_input.restriction" />
                    </span>
                </div>
                <Input
                    value={sloganState[SLOGAN_PROP]}
                    className={classes.input}
                    placeholder={translate(
                        'variations_display.marketplace_listing.filters.brand.slogan.placeholder'
                    )}
                    onChange={(e) => {
                        setDebouncedSlogan({
                            [SLOGAN_PROP]: e.currentTarget.value,
                        });
                        reportTextFieldsChanged({
                            location: LOCATION.STATIC,
                            field: TEXT_FIELDS.SLOGAN,
                        });
                    }}
                />
            </label>
        </div>
    );
};

BrandFilter.propTypes = {
    briefData: shape(BRIEF_DATA),
    setBriefData: func,
};

export default BrandFilter;
